export const PRICE = "R";

export const OTPMessage = "Enter OTP that has been sent to your mobile number.";

export const bannerType = [
    { id: 'normal', value: "Normal" },
    { id: 'category', value: "Category" },
    { id: 'offer', value: "Offer" }
]